import React, { Component } from 'react';
import {GameButtonContainer, GameButton, GameButtonAfterEl} from '../styled/GameButton';

class SuperButton extends Component {
  render() {
    const {
      width,
      height,
      children,
      status
    } = this.props;

    let backgroundColor = '#fff2d8';
    let secondaryBackgroundColor = '#dec38e';
    let clicked = false;

    switch (status) {
      case 0:
        backgroundColor = '#fff2d8';
        secondaryBackgroundColor = '#dec38e';
        clicked = false;
        break;
      case -1:
        backgroundColor = '#e36f6f';
        secondaryBackgroundColor = '#AF615F';
        clicked = true;
        break;
      case 1:
        backgroundColor = '#64c666';
        secondaryBackgroundColor = '#689F5E';
        clicked = true;
        break;
    }

    return (
      <GameButtonContainer
        height={height}
        width={width}
      >
        <GameButton
          backgroundColor={backgroundColor}
          clicked={clicked}
          onClick={this.props.onClick}
        >
          {children}
        </GameButton>
        <GameButtonAfterEl secondaryBackgroundColor={secondaryBackgroundColor}/>
      </GameButtonContainer>
    );
  }
}

export default SuperButton;
